import { NetworkProfile as ApiNetworkProfile } from '@infuse/api/e-connector/network-profile';
import { NetworkProfile } from './model';

export const mapToDomain = (apiNetworkProfile: ApiNetworkProfile): NetworkProfile => {
  return { ...apiNetworkProfile };
};

export const mapToApi = (networkProfile: NetworkProfile): ApiNetworkProfile => {
  return { ...networkProfile };
};
